import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginator'
})
export class PaginatorPipe implements PipeTransform {

  transform(values: any, valueFilter: string = ''): any {

  
    if (valueFilter.length === 0) {
      return values;
    } if (valueFilter === 'all') {

      return values;
    }
    const filterOportunities = values.data.filter((oportunitie: any) => oportunitie.type == valueFilter);
    return filterOportunities
  }

}
